import React, { createContext, useState, useContext, useEffect } from "react";
import { translations } from "../translations";
import { getWithExpiry, setWithExpiry } from "../utils/storage";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = getWithExpiry('bodyup-language') || getWithExpiry('trainiq-language');
    if (saved && (saved === 'fr' || saved === 'en')) return saved;
    return 'fr';
  });

  useEffect(() => {
    setWithExpiry('bodyup-language', language);
    localStorage.removeItem('trainiq-language');
    document.documentElement.lang = language;
  }, [language]);

  const toggleLanguage = () => setLanguage(prev => prev === 'fr' ? 'en' : 'fr');
  const t = translations[language];

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLanguage must be used within a LanguageProvider');
  return context;
};

export default LanguageContext;
